import { render, staticRenderFns } from "./VaccinePricingAndDoseDistribution.vue?vue&type=template&id=0ea6f5ba&"
import script from "./VaccinePricingAndDoseDistribution.vue?vue&type=script&lang=js&"
export * from "./VaccinePricingAndDoseDistribution.vue?vue&type=script&lang=js&"
import style0 from "./VaccinePricingAndDoseDistribution.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports